module.exports = __webpack_public_path__ + "static/img/img_cabinet.aa4b0647.png";